/**
 * Constants for worker initialization and communication
 */

export const WORKER_CONFIG = {
  // Worker initialization delays (ms)
  INITIALIZATION_DELAY: 800,
  VERIFICATION_RETRY_DELAY: 300,
  METHOD_CALL_DELAY: 500,
  
  // Retry configuration
  MAX_VERIFICATION_ATTEMPTS: 3,
  MAX_LOAD_RETRIES: 10,
  /** Inner retry budget per outer in-camera recovery attempt (keeps each attempt responsive). */
  MAX_RECOVERY_LOAD_RETRIES: 2,
  /**
   * Hard timeout for a single in-camera recovery attempt.
   * Blocked/hung network requests can leave
   * tf.loadGraphModel pending forever; without this the recovery loop never advances.
   */
  RECOVERY_ATTEMPT_TIMEOUT_MS: 25000,
  
  // Worker readiness polling
  READINESS_POLL_INTERVAL: 100,
  READINESS_MAX_WAIT: 1000,
  
  // Stack processing
  STACK_PROCESSING_LOCK_DELAY: 3,
} as const;

export const WORKER_ERROR_MESSAGES = {
  METHOD_NOT_FUNCTION: 'is not a function',
  RAW_VALUE_APPLY: 'rawValue.apply',
  CANNOT_READ_PROPERTY: 'Cannot read property',
  NOT_A_FUNCTION: 'not a function',
  UNDEFINED: 'undefined',
} as const;

export type WorkerErrorType = typeof WORKER_ERROR_MESSAGES[keyof typeof WORKER_ERROR_MESSAGES];

